"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heroFormUpsert = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../utils/endpoints");
const additionalFunctions_1 = require("../../services/additionalFunctions");
const endpoints = new endpoints_1.default;
const additionalFunctions = new additionalFunctions_1.AdditionalFunctions(endpoints.baseURL);
const heroFormUpsert = (form, callback) => __awaiter(void 0, void 0, void 0, function* () {
    axios_1.default.post(endpoints.upsertEndpoint, form)
        .then((response) => {
        if (response.data.success) {
            callback(form);
        }
        else {
            console.log(response.data);
        }
    })
        .catch((error) => {
        console.log(error.response);
    });
});
exports.heroFormUpsert = heroFormUpsert;
